// IMPORT PACKAGE REFERENCES
import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { getSticker, addSegmentToSticker, removeSegmentFromSticker, addEquipmentTypesToSticker, removeEquipmentTypeFromSticker } from '../../../state/actions/StickerActions';
import { getSegments } from '../../../state/actions/SegmentActions';
import { SegmentSection } from '../../Equipment/Details/SegmentSection';
import { Loading} from '../../../containers/Loading';
import { AddSegmentToItemModal } from '../../../modals/AddSegmentToItemModal';
import { EquipmentTypesSection } from './EquipmentTypesSection';
import { EquipmentTypeSelectionModal } from '../../../modals/EquipmentTypeSelectionModal';
import { ImageSection } from '../../../containers/ImageSection';

// COMPONENT
class StickerDetailPage extends React.Component {

    constructor(props) {
        super(props);
        
        this.state = {
            sticker: {},
            stickerName: '',
            segments: [],
            equipmentTypes: [],
            segmentModal: false,
            equipmentModal: false,
            imageName: ''
        };

        this.updateSegments = this.updateSegments.bind(this);
        this.removeSegment = this.removeSegment.bind(this);
        this.updateDependancies = this.updateDependancies.bind(this);
        this.toggleSegmentModal = this.toggleSegmentModal.bind(this);
        this.toggleTypeModal = this.toggleTypeModal.bind(this);
        this.addSegment = this.addSegment.bind(this);
        this.removeType = this.removeType.bind(this);
        this.addTypes = this.addTypes.bind(this);
        this.updateSticker = this.updateSticker.bind(this);
    }

    componentDidMount(){
        this.props.getSticker(this.props.match.params.stickerId);
    }

    updateDependancies(){
        if(this.props.sticker != {} && this.props.sticker != null) {
            this.updateSegments();
        }
    }

    updateSegments(){
        if(this.props.sticker.segments != null && this.props.sticker.segments != undefined) {
            this.props.getSegments(Object.keys(this.props.sticker.segments));
        }
    }

    componentDidUpdate(prevProps){
        if(JSON.stringify(this.props.sticker) != JSON.stringify(prevProps.sticker)) {
            this.setState({
                sticker: this.props.sticker,
                imageName: this.props.sticker['preview-image']
            });
            this.updateSticker();
        }

        if(this.props.addedEquipmentTypesToSticker && !prevProps.addedEquipmentTypesToSticker) {
            this.setState({
                sticker: this.props.sticker
            });
            this.updateSticker();
        }

        if(this.props.removedEquipmentTypesFromSticker && !prevProps.removedEquipmentTypesFromSticker){
            this.setState({sticker: this.props.sticker});
            this.updateSticker();
        }

        if(this.props.addedSegmentToSticker && !prevProps.addedSegmentToSticker) {
            this.setState({sticker: this.props.sticker});
            this.updateSticker();
        }

        if(this.props.removedSegmentFromSticker && !prevProps.removedSegmentFromSticker) {
            this.setState({sticker: this.props.sticker});
            this.updateSticker();
        }

        if(this.props.segments != prevProps.segments){
            this.setState({segments: this.props.segments});
        }
    }

    updateSticker(){
        if(this.props.sticker != undefined && this.props.sticker != null){
            this.setState({stickerName: this.props.sticker.name});
            this.updateDependancies();
        }

        if(this.props.sticker.equipmentTypes != undefined){
            this.setState({equipmentTypes: this.props.sticker.equipmentTypes});
        }
    }

    toggleTypeModal() {
        this.setState({
            equipmentModal: !this.state.equipmentModal
        });
    }
    
    removeType(type) {
        let newTypes = this.state.equipmentTypes.filter(v => v !== type); 
        this.props.removeEquipmentTypeFromSticker(newTypes, this.props.sticker.id);
    }

    addTypes(types) {
        this.props.addEquipmentTypesToSticker(types.concat(this.state.equipmentTypes), this.state.sticker.id);
    }

    toggleSegmentModal() {
        this.setState({
            segmentModal: !this.state.segmentModal
        });
    }

    addSegment(segmentID){
        this.props.addSegmentToSticker(segmentID, [this.props.match.params.stickerId]);
        this.updateSegments();
    }

    removeSegment(segmentId){
        this.props.removeSegmentFromSticker(segmentId, this.props.sticker.id);
    }

    render() {
        return (
            <Fragment>
                <div className="page-title">Sticker: {this.state.stickerName}</div>

                {(this.props.fetchingSticker || this.props.fetchingSegments) &&
                    <Loading/>
                }

                {!this.props.fetchingSegments && !this.props.fetchingSticker && this.state.sticker != {} && 
                    <div>
                        <ImageSection imageName={this.state.imageName} storageLocation={'preview-images'} width={300} height={150}/>
                        <EquipmentTypesSection types={this.state.equipmentTypes} toggleModal={this.toggleTypeModal} removeType={this.removeType}/>
                        <SegmentSection subtitle={''} emptyText={'There are no segments associated with this sticker'} deleteItem={this.removeSegment} segments={this.state.segments} toggleModal={this.toggleSegmentModal}/>
                    </div>
                }

                {true && <AddSegmentToItemModal isOpen={this.state.segmentModal} toggleModal={this.toggleSegmentModal} addSegment={this.addSegment} assignedSegments={this.state.segments}/>}
                {true && <EquipmentTypeSelectionModal isOpen={this.state.equipmentModal} toggleModal={this.toggleTypeModal} addTypes={this.addTypes} assignedTypes={this.state.equipmentTypes}/>}

            </Fragment>
        );
    }
}

StickerDetailPage.propTypes = {
    getSticker: PropTypes.func.isRequired,
    getSegments: PropTypes.func.isRequired,
    removeSegmentFromSticker: PropTypes.func.isRequired,
    location: PropTypes.object.isRequired,
    history: PropTypes.object.isRequired,
    sticker: PropTypes.object.isRequired,
    segments: PropTypes.array.isRequired,
    fetchingSticker: PropTypes.bool.isRequired,
    fetchedSticker: PropTypes.bool.isRequired,
    failedSticker: PropTypes.bool.isRequired,
    match: PropTypes.object.isRequired,
    fetchingSegments: PropTypes.bool.isRequired,
    fetchedSegments: PropTypes.bool.isRequired,
    failedSegments: PropTypes.bool.isRequired,
    addSegmentToSticker: PropTypes.func.isRequired,
    addedSegmentToSticker: PropTypes.bool.isRequired,
    addingSegmentToSticker: PropTypes.bool.isRequired,
    addEquipmentTypesToSticker: PropTypes.func.isRequired, 
    removeEquipmentTypeFromSticker: PropTypes.func.isRequired,
    addingEquipmentTypesToSticker: PropTypes.bool.isRequired,
    addedEquipmentTypesToSticker: PropTypes.bool.isRequired,
    addEquipmentTypesToStickerFailed: PropTypes.bool.isRequired,
    removingEquipmentTypesFromSticker: PropTypes.bool.isRequired,
    removedEquipmentTypesFromSticker: PropTypes.bool.isRequired,
    removingSegmentFromSticker: PropTypes.bool.isRequired,
    removedSegmentFromSticker: PropTypes.bool.isRequired
};

// CONFIGURE REACT REDUX
const mapStateToProps = state => {
    const { sticker, fetchingSticker, fetchedSticker, failedSticker, addingSegmentToSticker, addedSegmentToSticker, addingEquipmentTypesToSticker, addedEquipmentTypesToSticker, addEquipmentTypesToStickerFailed, 
        removingEquipmentTypesFromSticker, removedEquipmentTypesFromSticker, removingSegmentFromSticker, removedSegmentFromSticker } = state.stickerReducer;
    const { segments, fetchingSegments, fetchedSegments, failedSegments } = state.segmentReducer;
    return { sticker, segments, fetchingSticker, fetchedSticker, failedSticker, fetchingSegments, fetchedSegments, failedSegments, addingSegmentToSticker, addedSegmentToSticker, addingEquipmentTypesToSticker, 
        addedEquipmentTypesToSticker, addEquipmentTypesToStickerFailed, removingEquipmentTypesFromSticker, removedEquipmentTypesFromSticker, removingSegmentFromSticker, removedSegmentFromSticker }; 
};

const mapDispatchToProps = dispatch => (
    bindActionCreators({ getSticker, getSegments, removeSegmentFromSticker, addSegmentToSticker, addEquipmentTypesToSticker, removeEquipmentTypeFromSticker }, dispatch)
);

// CONFIGURE REACT REDUX
const hoc = withRouter(connect(mapStateToProps, mapDispatchToProps)(StickerDetailPage));

// EXPORT COMPONENT

export { hoc as StickerDetailPage };


// WEBPACK FOOTER //
// ./src/components/pages/Stickers/Detail/StickerDetailPage.js